type Args = {
	readonly label: string;
	readonly detail: string;
	readonly footnote: string | null;
};

/** The wording of one transfer status: a title, one sentence of help and an optional reassurance. */
class TransferPresentationView {
	readonly label: string;
	readonly detail: string;
	readonly footnote: string | null;

	constructor(parts: Args) {
		this.label = parts.label;
		this.detail = parts.detail;
		this.footnote = parts.footnote;

		Object.freeze(this);
	}
}

export default TransferPresentationView;
